"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('share', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "35",
    cy: "11",
    r: "5"
  }), _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "13",
    cy: "24",
    r: "5"
  }), _react.default.createElement("path", {
    d: "M23.6423044,10.0082003 L23.6965665,24.8117002",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(23.669435, 17.409950) rotate(59.000000) translate(-23.669435, -17.409950) "
  }), _react.default.createElement("path", {
    d: "M24.9551891,22.8156405 L23.0629677,38.1950885",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(24.009078, 30.505365) rotate(-66.434949) translate(-24.009078, -30.505365) "
  }), _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    transform: "translate(35.000000, 37.000000) scale(1, -1) translate(-35.000000, -37.000000) ",
    cx: "35",
    cy: "37",
    r: "5"
  }))));
});

exports.default = _default;